/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Lob,
    LobFromJSON,
    LobToJSON,
} from '../models/Lob';
import {
    type Office,
    OfficeFromJSON,
    OfficeToJSON,
} from '../models/Office';
import {
    type UnderwritingYear,
    UnderwritingYearFromJSON,
    UnderwritingYearToJSON,
} from '../models/UnderwritingYear';

export interface CreateLobRequest {
    lob: Lob;
}

export interface CreateOfficeRequest {
    office: Office;
}

export interface CreateUnderwritingYearRequest {
    underwritingYear: UnderwritingYear;
}

export interface DeleteLobRequest {
    key: string;
}

export interface DeleteOfficeRequest {
    key: string;
}

export interface DeleteUnderwritingYearRequest {
    year: number;
}

export interface GetLobRequest {
    key: string;
}

export interface GetOfficeRequest {
    key: string;
}

export interface UpdateLobRequest {
    key: string;
    lob: Lob;
}

export interface UpdateOfficeRequest {
    key: string;
    office: Office;
}

/**
 * 
 */
export class RefdataApi extends runtime.BaseAPI {

    /**
     * Creates request options for createLob without sending the request
     */
    async createLobRequestOpts(requestParameters: CreateLobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['lob'] == null) {
            throw new runtime.RequiredError(
                'lob',
                'Required parameter "lob" was null or undefined when calling createLob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/lob`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LobToJSON(requestParameters['lob']),
        };
    }

    /**
     */
    async createLobRaw(requestParameters: CreateLobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Lob>> {
        const requestOptions = await this.createLobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LobFromJSON(jsonValue));
    }

    /**
     */
    async createLob(requestParameters: CreateLobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Lob> {
        const response = await this.createLobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOffice without sending the request
     */
    async createOfficeRequestOpts(requestParameters: CreateOfficeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['office'] == null) {
            throw new runtime.RequiredError(
                'office',
                'Required parameter "office" was null or undefined when calling createOffice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/office`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OfficeToJSON(requestParameters['office']),
        };
    }

    /**
     */
    async createOfficeRaw(requestParameters: CreateOfficeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Office>> {
        const requestOptions = await this.createOfficeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OfficeFromJSON(jsonValue));
    }

    /**
     */
    async createOffice(requestParameters: CreateOfficeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Office> {
        const response = await this.createOfficeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createUnderwritingYear without sending the request
     */
    async createUnderwritingYearRequestOpts(requestParameters: CreateUnderwritingYearRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['underwritingYear'] == null) {
            throw new runtime.RequiredError(
                'underwritingYear',
                'Required parameter "underwritingYear" was null or undefined when calling createUnderwritingYear().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/uwy`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UnderwritingYearToJSON(requestParameters['underwritingYear']),
        };
    }

    /**
     */
    async createUnderwritingYearRaw(requestParameters: CreateUnderwritingYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnderwritingYear>> {
        const requestOptions = await this.createUnderwritingYearRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnderwritingYearFromJSON(jsonValue));
    }

    /**
     */
    async createUnderwritingYear(requestParameters: CreateUnderwritingYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnderwritingYear> {
        const response = await this.createUnderwritingYearRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteLob without sending the request
     */
    async deleteLobRequestOpts(requestParameters: DeleteLobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling deleteLob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/lob/{key}`;
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteLobRaw(requestParameters: DeleteLobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteLobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteLob(requestParameters: DeleteLobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLobRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteOffice without sending the request
     */
    async deleteOfficeRequestOpts(requestParameters: DeleteOfficeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling deleteOffice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/office/{key}`;
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteOfficeRaw(requestParameters: DeleteOfficeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteOfficeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteOffice(requestParameters: DeleteOfficeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOfficeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteUnderwritingYear without sending the request
     */
    async deleteUnderwritingYearRequestOpts(requestParameters: DeleteUnderwritingYearRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling deleteUnderwritingYear().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/uwy/{year}`;
        urlPath = urlPath.replace('{year}', encodeURIComponent(String(requestParameters['year'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteUnderwritingYearRaw(requestParameters: DeleteUnderwritingYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteUnderwritingYearRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteUnderwritingYear(requestParameters: DeleteUnderwritingYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUnderwritingYearRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getLob without sending the request
     */
    async getLobRequestOpts(requestParameters: GetLobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getLob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/lob/{key}`;
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getLobRaw(requestParameters: GetLobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Lob>> {
        const requestOptions = await this.getLobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LobFromJSON(jsonValue));
    }

    /**
     */
    async getLob(requestParameters: GetLobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Lob> {
        const response = await this.getLobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLobs without sending the request
     */
    async getLobsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/lob`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getLobsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Lob>>> {
        const requestOptions = await this.getLobsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LobFromJSON));
    }

    /**
     */
    async getLobs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Lob>> {
        const response = await this.getLobsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOffice without sending the request
     */
    async getOfficeRequestOpts(requestParameters: GetOfficeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getOffice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/office/{key}`;
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getOfficeRaw(requestParameters: GetOfficeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Office>> {
        const requestOptions = await this.getOfficeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OfficeFromJSON(jsonValue));
    }

    /**
     */
    async getOffice(requestParameters: GetOfficeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Office> {
        const response = await this.getOfficeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOffices without sending the request
     */
    async getOfficesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/office`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getOfficesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Office>>> {
        const requestOptions = await this.getOfficesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OfficeFromJSON));
    }

    /**
     */
    async getOffices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Office>> {
        const response = await this.getOfficesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUnderwritingYears without sending the request
     */
    async getUnderwritingYearsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/uwy`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getUnderwritingYearsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UnderwritingYear>>> {
        const requestOptions = await this.getUnderwritingYearsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UnderwritingYearFromJSON));
    }

    /**
     */
    async getUnderwritingYears(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UnderwritingYear>> {
        const response = await this.getUnderwritingYearsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLob without sending the request
     */
    async updateLobRequestOpts(requestParameters: UpdateLobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updateLob().'
            );
        }

        if (requestParameters['lob'] == null) {
            throw new runtime.RequiredError(
                'lob',
                'Required parameter "lob" was null or undefined when calling updateLob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/lob/{key}`;
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: LobToJSON(requestParameters['lob']),
        };
    }

    /**
     */
    async updateLobRaw(requestParameters: UpdateLobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateLobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLob(requestParameters: UpdateLobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLobRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateOffice without sending the request
     */
    async updateOfficeRequestOpts(requestParameters: UpdateOfficeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updateOffice().'
            );
        }

        if (requestParameters['office'] == null) {
            throw new runtime.RequiredError(
                'office',
                'Required parameter "office" was null or undefined when calling updateOffice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/ref/office/{key}`;
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: OfficeToJSON(requestParameters['office']),
        };
    }

    /**
     */
    async updateOfficeRaw(requestParameters: UpdateOfficeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateOfficeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateOffice(requestParameters: UpdateOfficeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOfficeRaw(requestParameters, initOverrides);
    }

}
